import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { version as CLIENT_VERSION } from '../../package.json'

const X_CLIENT_VERSION_HEADER = 'X-Client-Version'
const X_API_DEPRECATED_HEADER = 'X-API-Deprecated'
const HTTP_UPGRADE_REQUIRED = 426
const VERSION_UPDATE_DISMISSED_KEY = 'client_version_update_dismissed'

type VersionUpdateListener = () => void

class ClientVersionManager {
    private listeners = new Set<VersionUpdateListener>()
    private notificationEmitted = false
    private upgradeRefreshTriggered = false

    subscribe(listener: VersionUpdateListener) {
        this.listeners.add(listener)
        return () => {
            this.listeners.delete(listener)
        }
    }

    markNotificationDismissed() {
        sessionStorage.setItem(VERSION_UPDATE_DISMISSED_KEY, 'true')
    }

    refreshApp() {
        window.location.reload()
    }

    handleUpgradeRequired() {
        if (this.upgradeRefreshTriggered) {
            return
        }
        this.upgradeRefreshTriggered = true
        this.refreshApp()
    }

    handleDeprecationHeaders(headers: Record<string, unknown>) {
        const deprecated =
            headers[X_API_DEPRECATED_HEADER] ?? headers[X_API_DEPRECATED_HEADER.toLowerCase()]
        if (deprecated !== 'true') {
            return
        }
        this.notifyDeprecationWarning()
    }

    private notifyDeprecationWarning() {
        if (this.notificationEmitted || sessionStorage.getItem(VERSION_UPDATE_DISMISSED_KEY) === 'true') {
            return
        }
        this.notificationEmitted = true
        this.listeners.forEach((listener) => listener())
    }
}

export const clientVersionManager = new ClientVersionManager()

export function applyClientVersionHeader(config: InternalAxiosRequestConfig) {
    config.headers[X_CLIENT_VERSION_HEADER] = CLIENT_VERSION
}

export function handleClientVersionSuccessResponse(response: AxiosResponse) {
    clientVersionManager.handleDeprecationHeaders(response.headers as Record<string, unknown>)
    return response
}

export function handleClientVersionError(error: AxiosError) {
    if (error.response?.status !== HTTP_UPGRADE_REQUIRED) {
        return false
    }
    clientVersionManager.handleUpgradeRequired()
    return true
}
